import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/facebook.svg',
})
export class FacebookComponent {}
